//#region src/lib/crawl/constants.ts
/** Zyte contract price per million requests, in USD, by request kind. */
const ZYTE_PRICE_PER_MILLION_USD = {
	http: 139,
	browser: 639
};
/** Monthly minimum of the Zyte contract, in USD; the bill is never below it. */
const ZYTE_CONTRACT_MONTHLY_MINIMUM_USD = 4170;
/** Spending limit, in USD, at which Zyte pauses the API for the rest of the month. */
const ZYTE_SPENDING_LIMIT_USD = 8340;

//#endregion
export { ZYTE_CONTRACT_MONTHLY_MINIMUM_USD, ZYTE_PRICE_PER_MILLION_USD, ZYTE_SPENDING_LIMIT_USD };
//# sourceMappingURL=constants.js.map